import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Material, AddMaterialDTO} from '../types'

type Variables = {plantCode: string; dto: AddMaterialDTO}

export const useAddMaterial = ({
  onError,
  onSuccess,
  onSettled
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: Material, variables: Variables) => void
  onSettled?: (data: Material | undefined, error: AxiosError | null, variables: Variables) => void
} = {}) =>
  useMutation<Material, AxiosError, Variables>({
    mutationFn: async ({plantCode, dto}) => {
      const response = await ApiClient.axiosInstance.post<Material>(
        `/plants/${plantCode}/materials`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess,
    onSettled
  })
